import React from "react"

import { Container } from "./styled"
import * as Styled from "../Icons/styled"

const About = () => {
  return (
    <>
      <Container>
        <div className="flex-container">
          <div className="card">
            <h2>Desenvolvedor Front-End</h2>
            <p>
              Minha paixão e desenvolver <strong>Layouts Responsivos</strong> e
              intuitivos que auxiliaram o usuário a alcançar seus objetivos
              dentro de uma aplicação.
            </p>
          </div>
          <div className="card">
            <h2>Web Master</h2>
            <p>
              Assessorar o proprietário do Website quanto a alterações e
              melhorias.
              <br />
              Garantir que o meu cliente apareça no <strong>Google</strong> ou
              em qualquer outro buscador na internet.
            </p>
          </div>
          <div className="card">
            <h2>Experiências</h2>
            <p>
              Atualmente gerencio <strong>WebSites </strong>
              de vários ramos comercias.
              <br />
              Possuo conhecimentos em aplicações <strong>Mobiles </strong>
              em especial na tecnologia <strong> React</strong>.
            </p>
          </div>
          <div className="card">
            <h2>
              <Styled.HeartsWrapper /> Valores
            </h2>
            <p>Profissionalismo</p>
            <p>Transparência;</p>
            & <br />
            <p>Gratidão.</p>
          </div>
        </div>
      </Container>
    </>
  )
}

export default About
